import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { JUKE_PATH } from '@constant'

export default class extends Component {
  render() {
    let header = [<Link to={JUKE_PATH}>聚客宝</Link>, '聚客宝规则']
    return (
      <HeaderView title="聚客宝规则" header={header}>
        <div style={{ padding: '40px 0' }}>
          <img src="https://qnm.hunliji.com/o_1coaemuo33pu1ktt16vff3lle.jpg" />
        </div>
      </HeaderView>
    )
  }
}
